import { render, staticRenderFns } from "./SearchResultDocumentItem.vue?vue&type=template&id=3e7e285f&scoped=true&"
import script from "./SearchResultDocumentItem.vue?vue&type=script&lang=js&"
export * from "./SearchResultDocumentItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultDocumentItem.vue?vue&type=style&index=0&id=3e7e285f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e285f",
  null
  
)

export default component.exports